module.exports = __webpack_public_path__ + "img/phone.7bf2d1a0.png";